<div *ngIf="IsLoading">Loading...</div>

<H1>{{this.site.name}}</H1>

<div *ngIf="ShowUndo" class="undo">
    <button mat-mini-fab
            class="undo-button"
            color="primary"
            (click)="this.undo()"
            aria-label="undo"
            title="undo {{this.UndoAction}}">
        <mat-icon>undo</mat-icon>
        <p>UNDO</p>
    </button>
</div>

<!--
    Tab 1: set up site roles
    Tab 2: set up folder roles
    Tab 3: set up templates (FolderPermissionExpression) and permissions (FolderRolePermissionExpression)
    Tab 4: set up folder tree (Folder), assign role members (FolderRoleMember)
    -->
<mat-drawer-container class="drawer-container" autosize>
    <mat-tab-group #tabs [(selectedIndex)]="selectedTabIndex">
        <!--Tab 1: Site-Level Roles -->
        <mat-tab label="Site-level Roles" *ngIf="!ShowRoleMembersTabOnly">
            <div class="site-roles-tab">
                <app-permission-roles *ngIf="this.SiteRoles != null"
                                      [roles]="this.SiteRoles"
                                      [membersInRoles]="this.MembersInRoles"
                                      (editRoleMembers)="this.editSiteLevelRoleMembershipClicked($event)"></app-permission-roles>
            </div>
        </mat-tab>

        <!--Tab 2: Folder-level Roles -->
        <mat-tab label="Folder-level Roles" *ngIf="!ShowRoleMembersTabOnly">
            <div class="site-roles-tab">
                <app-folder-permissions (changeTabIndex)="this.OpenFRMTab()"
                                        [roles]="this.SiteRoles"
                                        [membersInRoles]="this.MembersInRoles">
                </app-folder-permissions>
            </div>
        </mat-tab>

        <!-- Tab 3: Permission Templates -->
        <mat-tab label="Permission Templates" *ngIf="!ShowRoleMembersTabOnly">
            <div class="tab-contents">
                <!-- Tab 3: Left Side: Templates [FolderPermissionExpression] -->
                <div class="tab-template-list">
                    <div *ngIf="SitePermissionExpressions?.length > 0" class="templates-grid">
                        <div class="templates-grid-heading">Tag</div>
                        <div class="templates-grid-heading">Name</div>
                        <div class="templates-grid-heading">Description</div>
                        <div></div>

                        <ng-container *ngFor="let template of this.SitePermissionExpressions">
                            <div (click)="SelectTemplate(template.id)" [ngClass]="template.id == SelectedTemplateId ? 'tag-green' : 'tag-gray'"
                                 class="template-tag tag-list" title="{{template.id}}">{{template.tag}}</div>
                            <div (click)="SelectTemplate(template.id)" [ngClass]="template.id == SelectedTemplateId ? 'selected-template' : ''"
                                 class="template-name" *ngIf="template.name">{{template.name}}</div>
                            <div (click)="SelectTemplate(template.id)" [ngClass]="template.id == SelectedTemplateId ? 'selected-template' : ''"
                                 class="template-description">
                                <span *ngIf="template.description">{{template.description}}</span>
                            </div>
                            <div>
                            </div>
                        </ng-container>
                    </div>
                    <br />
                    <form [formGroup]="addTemplateForm">
                        <button *ngIf="!ShowAddEditTemplateForm" class="theme-primary-btn mat-raised-button" mat-flat-button color="primary" (click)="addPermissionTemplate()">Add Template</button>
                        <button *ngIf="SelectedTemplateId" class="theme-primary-btn" mat-flat-button color="primary" (click)="editPermissionTemplate()">Edit Template</button>
                        <button *ngIf="SelectedTemplateId" class="theme-primary-btn" mat-flat-button color="warn" (click)="deletePermissionTemplate()">Delete</button>

                        <div *ngIf="ShowAddEditTemplateForm">
                            <div class="templates-grid-heading">Tag</div>
                            <div><input maxlength="7" type="text" required autofocus formControlName="tag" (change)="tagChangeEvent($event)"></div>
                            <br />
                            <div class="templates-grid-heading">Name</div>
                            <div><input maxlength="256" type="text" class="template-data-entry" required formControlName="name"></div>
                            <br />
                            <div class="templates-grid-heading">Description</div>
                            <textarea maxlength="1000" type="text" class="template-data-entry" formControlName="description"></textarea>
                            <br />
                            <div>
                                <button class="theme-primary-btn" mat-flat-button color="primary" [disabled]="!addTemplateForm.valid" (click)="savePermissionTemplate()">Save</button>
                                &nbsp;
                                <button class="theme-primary-btn" mat-flat-button color="basic" (click)="CancelAddPermissionTemplate()">Cancel</button>
                            </div>
                        </div>
                    </form>
                </div>

                <!-- Tab 3: Right Side: Roles [FolderRolePermissionExpression] -->
                <div class="tab-selected-template-roles">
                    <div *ngIf="!SelectedTemplateFRPEs">
                        Please select a permission template to configure roles.
                    </div>
                    <mat-expansion-panel class="role-panel" *ngFor="let selFRPE of SelectedTemplateFRPEs">
                        <mat-expansion-panel-header title="{{selFRPE.roleName}}">
                            <mat-panel-title>
                                <div style="width: 100%; flex-grow: 1;">
                                    <div class="icon-div">
                                        <mat-icon *ngIf="selFRPE.roleIsSiteLevel" class="material-icons-outlined" title="Site-level">collections</mat-icon>
                                    </div>
                                    <div class="role-name-for-dropdown">
                                        <strong>{{selFRPE.roleName}}</strong>
                                    </div>
                                </div>
                            </mat-panel-title>

                            <div class="perm-indicator">
                                <mat-icon title="Folders" class="perm-indicator-type" [ngClass]="(selFRPE.canViewFolder || selFRPE.canCreateFolder || selFRPE.canDeleteFolder) ? 'perm-on' : 'perm-off'">folder</mat-icon>
                                <mat-icon title="Create Folders" class="material-icons-outlined" [ngClass]="selFRPE.canCreateFolder ? 'perm-on' : 'perm-off'">add</mat-icon>
                                <mat-icon title="Delete Folders" class="material-icons-outlined" [ngClass]="selFRPE.canDeleteFolder ? 'perm-on' : 'perm-off'">close</mat-icon>
                                <mat-icon title="View Folders" class="material-icons-outlined" [ngClass]="selFRPE.canViewFolder ? 'perm-on' : 'perm-off'">visibility</mat-icon>
                                &nbsp; &nbsp;
                                <mat-icon title="Forms" class="perm-indicator-type" [ngClass]="(selFRPE.canCreateForm || selFRPE.canDeleteForm) ? 'perm-on' : 'perm-off'">article</mat-icon>
                                <mat-icon title="Create Forms" class="material-icons-outlined" [ngClass]="selFRPE.canCreateForm ? 'perm-on' : 'perm-off'">add</mat-icon>
                                <mat-icon title="Delete Forms" class="material-icons-outlined" [ngClass]="selFRPE.canDeleteForm ? 'perm-on' : 'perm-off'">close</mat-icon>
                                <mat-icon title="Reorder Forms" class="material-icons-outlined" [ngClass]="selFRPE.canReorderForms ? 'perm-on' : 'perm-off'">reorder</mat-icon>
                                &nbsp; &nbsp;
                                <mat-icon title="Grant Permissions" class="material-icons-outlined" [ngClass]="selFRPE.canGrantPermission ? 'perm-on' : 'perm-off'">library_add_check</mat-icon>
                                &nbsp;
                                <mat-icon title="Manage Role Members" class="material-icons-outlined" [ngClass]="selFRPE.canManageRoleMembers ? 'perm-on' : 'perm-off'">group_add</mat-icon>
                                <span *ngIf="selFRPE.roleIsSiteLevel">
                                    &nbsp; &nbsp;
                                    <mat-icon title="Form Field Constraints" class="material-icons-outlined" [ngClass]="selFRPE.canBuildConstraints ? 'perm-on' : 'perm-off'">transform</mat-icon>
                                    <mat-icon title="Workflow" class="material-icons-outlined" [ngClass]="selFRPE.canBuildWorkflows ? 'perm-on' : 'perm-off'">timeline</mat-icon>
                                    <mat-icon svgIcon="material-export-notes" title="Publishing" [ngClass]="selFRPE.canPublish ? 'perm-on' : 'perm-off'"></mat-icon>
                                    &nbsp; &nbsp;
                                    <span [ngClass]="selFRPE.canEditFormTemplateHtml ? 'perm-on' : 'perm-off'">
                                        <span style="position: absolute;">F</span>
                                        <mat-icon style="margin-left: 10px;" title="Edit Forms HTML" class="material-icons-outlined">code</mat-icon>
                                    </span>
                                    &nbsp;
                                    <span [ngClass]="selFRPE.canEditSiteHomePageHtml ? 'perm-on' : 'perm-off'">
                                        <span style="position: absolute;">H</span>
                                        <mat-icon style="margin-left: 10px;" title="Edit Site HTML" class="material-icons-outlined">code</mat-icon>
                                    </span>
                                </span>
                            </div>
                        </mat-expansion-panel-header>

                        <div>
                            <span class="permission-category">Folders</span>
                            <!-- Note:  the following check box ids consist of a ten character prefix followed by a dash and the folder role permissions expression Id. -->
                            <mat-checkbox id="CreateFold-{{selFRPE.id}}" class="permission-checkbox" [checked]="selFRPE.canCreateFolder"
                                          (change)="updateFRPE($event, selFRPE.id, selFRPE.roleId);">Add</mat-checkbox>
                            <mat-checkbox id="DeleteFold-{{selFRPE.id}}" class="permission-checkbox" [checked]="selFRPE.canDeleteFolder"
                                          (change)="updateFRPE($event, selFRPE.id, selFRPE.roleId);">Delete</mat-checkbox>
                            <mat-checkbox id="ViewFolder-{{selFRPE.id}}" class="permission-checkbox" [checked]="selFRPE.canViewFolder"
                                          (change)="updateFRPE($event, selFRPE.id, selFRPE.roleId);">View</mat-checkbox>
                            <br />
                            <span class="permission-category">Forms</span>
                            <mat-checkbox id="CreateForm-{{selFRPE.id}}" class="permission-checkbox" [checked]="selFRPE.canCreateForm"
                                          (change)="updateFRPE($event, selFRPE.id, selFRPE.roleId);">Add</mat-checkbox>
                            <mat-checkbox id="DeleteForm-{{selFRPE.id}}" class="permission-checkbox" [checked]="selFRPE.canDeleteForm"
                                          (change)="updateFRPE($event, selFRPE.id, selFRPE.roleId);;">Delete</mat-checkbox>
                            <mat-checkbox id="ReordrForm-{{selFRPE.id}}" class="permission-checkbox" [checked]="selFRPE.canReorderForms"
                                          (change)="updateFRPE($event, selFRPE.id, selFRPE.roleId);;">Reorder</mat-checkbox>
                            <span class="permission-checkbox" id="alignment-filler"></span>
                            <br />
                            <span class="permission-category">Permissions</span>
                            <mat-checkbox id="GrantPermi-{{selFRPE.id}}" class="permission-checkbox" [checked]="selFRPE.canGrantPermission"
                                          (change)="updateFRPE($event, selFRPE.id, selFRPE.roleId);">Grant</mat-checkbox>
                            <mat-checkbox id="ManagePerm-{{selFRPE.id}}" class="permission-checkbox" [checked]="selFRPE.canManageRoleMembers"
                                          (change)="updateFRPE($event, selFRPE.id, selFRPE.roleId);" style="width: auto;">Manage Role Members</mat-checkbox>
                        </div>
                        <div *ngIf="selFRPE.roleIsSiteLevel">
                            <span class="permission-category">Advanced</span>
                            <mat-checkbox id="Constraints-{{selFRPE.id}}" class="permission-checkbox" [checked]="selFRPE.canBuildConstraints"
                                          (change)="updateFRPE($event, selFRPE.id, selFRPE.roleId);">Constraints</mat-checkbox>
                            <mat-checkbox id="CreateWorkflow-{{selFRPE.id}}" class="permission-checkbox" [checked]="selFRPE.canBuildWorkflows"
                                          (change)="updateFRPE($event, selFRPE.id, selFRPE.roleId);">Workflow</mat-checkbox>
                            <mat-checkbox id="Can_Publish-{{selFRPE.id}}" class="permission-checkbox" [checked]="selFRPE.canPublish"
                                          (change)="updateFRPE($event, selFRPE.id, selFRPE.roleId);">Publishing</mat-checkbox>
                            <br />
                            <span class="permission-category">HTML Edit</span>
                            <mat-checkbox id="EditFormHTML-{{selFRPE.id}}" class="permission-checkbox" [checked]="selFRPE.canEditFormTemplateHtml"
                                          (change)="updateFRPE($event, selFRPE.id, selFRPE.roleId);">Forms</mat-checkbox>
                            <mat-checkbox id="EditSiteHTML-{{selFRPE.id}}" class="permission-checkbox" [checked]="selFRPE.canEditSiteHomePageHtml"
                                          (change)="updateFRPE($event, selFRPE.id, selFRPE.roleId);" style="width: auto;">Site Homepage</mat-checkbox>
                        </div>
                        <br />
                    </mat-expansion-panel>

                    <br /><br />

                    <div *ngFor="let role of SiteRoles">
                        <div *ngIf="ShowActivateRole(role.id)" class="activate-role-row">
                            <div class="activate-button">
                                <button mat-raised-button
                                        color="primary"
                                        title="Activate Role for Template"
                                        (click)="this.activateRoleForTemplate(role.id)">
                                    Activate
                                </button>
                            </div>
                            <div class="activate-site-role-icon">
                                <mat-icon *ngIf="role.isSiteLevel" class="material-icons-outlined site-level-icon" title="Site-level role (use Site-level Roles tab to manage members)">collections</mat-icon>
                            </div>
                            <div>
                                <strong class="role-name">{{role.name}}</strong>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </mat-tab>

        <!-- Tab 4: Folders, Roles and Members  -->
        <mat-tab label="Folders, Roles and Members">
            <div class="tab-contents">
                <!-- Tab 4: Left Side [Folder] -->
                <div class="tab-folder-tree">
                    <div style="flex-direction: row; flex-grow: 1;">
                        <!--    [scrollHeight]="'calc(100vh - 330px)'" makes folder tree height responsive to browser height -->
                        <p-tree [scrollHeight]="'calc(100vh - 330px)'"
                                [value]="TreeData"
                                (onNodeSelect)="selectFolderInTree($event)"
                                selectionMode="single"
                                [(selection)]="SelectedNode"
                                (keyup)="treeNodeKeyup($event)"
                                [filter]="TreeData?.length > 0"
                                [draggableNodes]="true"
                                [droppableNodes]="true"
                                draggableScope="self"
                                droppableScope="self"
                                (onNodeDrop)="onDrop($event)"
                                filterMode="strict"
                                filterPlaceholder="search"
                                filterBy="label"
                                emptyMessage="no folders">
                            <ng-template let-node pTemplate="Folder">
                                <div class="tree-node-div">
                                    <span class="folder-tree-tag" [ngClass]="node.data.FPE_ID == Selected_Folder_FPE_ID ? 'tag-green' : 'tag-gray'"
                                          title="{{node.data.templateName}} template">{{node.data.tag}}</span>
                                    <mat-icon title="{{node.data.isTransparentFolder ? 'Transparent' : ''}} folder" class="{{node.iconClass}} float-left">
                                        {{node.icon}}
                                    </mat-icon>
                                    <span class="folder-name" *ngIf="!FolderRenameInProgress || node.data.id != SelectedFolderId" title="{{node.label}}">
                                        {{node.label}}
                                    </span>
                                    <span *ngIf="FolderRenameInProgress && node.data.id == SelectedFolderId">
                                        <input matInput #folderNameInput
                                               class="folder-name-input"
                                               value="{{node.label}}"
                                               (blur)="renameFolderCancel()"
                                               (keyup.enter)="renameFolder($event)"
                                               (keyup.escape)="renameFolderCancel()"
                                               (onfocusout)="renameFolderCancel()"
                                               maxlength="256" type="text"
                                               id="folder-name-input{{node.data.id}}">
                                    </span>
                                    <span *ngIf="!FolderRenameInProgress && node.data.id == SelectedFolderId" class="rename-link" title="Rename folder" (click)="renameFolderClick(node.data.id)">
                                        <mat-icon class="material-icons">edit</mat-icon>
                                    </span>
                                    <span *ngIf="FolderRenameInProgress && node.data.id == SelectedFolderId" class="cancel-rename-link" title="Cancel rename folder" (click)="renameFolderCancel()">
                                        <mat-icon class="material-icons">cancel</mat-icon>
                                    </span>
                                </div>
                            </ng-template>
                        </p-tree>
                        <br />
                        <div style="padding-bottom: 5px;">
                            <div class="float-left">
                                <button mat-raised-button (click)="addFolder()" color="primary" title="Add new folder">
                                    <mat-icon class="material-icons-outlined button-with-icon">create_new_folder</mat-icon>
                                    Add
                                </button>
                            </div>
                            <div *ngIf="this.SelectedFolderId" class="float-left">
                                <button mat-raised-button (click)="deleteFolder()" color="warn" title="Delete selected folder">
                                    <mat-icon class="material-icons-outlined button-with-icon">close</mat-icon>
                                    Delete
                                </button>
                            </div>
                            <div *ngIf="ShowResetFolders" style="float: right;">
                                <button mat-raised-button (click)="this.assignDefaultToAll()" color="secondary" title="Reset folders">
                                    <mat-icon class="material-icons-outlined button-with-icon">folder_off</mat-icon>
                                    Reset
                                </button>
                            </div>
                        </div>
                        <br />
                    </div>
                </div>

                <!-- Tab 4: Right Side [FolderRoleMember] -->
                <div *ngIf="!NoFolderData">
                    <div *ngIf="!SelectedFolderId" style="min-width: 620px;">
                        <br /><br />
                        Select a folder to configure roles.
                    </div>
                </div>
                <div class="selected-folder-info" *ngIf="SelectedFolderId">
                    <mat-form-field>
                        <mat-select [value]="Selected_Folder_FPE_ID" (selectionChange)="updateSelectedFPE_ID($event.value)">
                            <mat-option *ngFor="let fpe of SitePermissionExpressions" [value]="fpe.id">
                                <span *ngIf="!fpe.name">&nbsp; ID: {{fpe.id}} </span>
                                {{fpe.name}}
                            </mat-option>
                            <mat-option [value]="0">
                                <span>no template</span>
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                    &nbsp;
                    <button class="theme-primary-btn" mat-flat-button color="primary" (click)="setFPEForFolder()">Set template</button>
                    &nbsp;

                    <mat-checkbox name="apply-fpe-to-descendents-checkbox" (change)="applyToSubfoldersChecked($event)">
                        Apply to subfolders
                    </mat-checkbox>
                    &nbsp;
                    <mat-checkbox name="lock-FPE-checkbox" (change)="lockFPEChecked($event)">
                        Lock template
                    </mat-checkbox>
                    <mat-icon class="info-mat-icon"
                              matTooltip="'Locked' now means that a user with grant permission on a folder cannot change the folder's permission expression."
                              matTooltipPosition="above">info</mat-icon>
                    <br /><br />

                    <div *ngIf="!SelectedFRPEs">
                        Use the Permission Templates tab to activate roles for this template.
                    </div>

                    <mat-expansion-panel *ngFor="let FRPE of SelectedFRPEs" class="role-member-panel">
                        <mat-expansion-panel-header title="{{FRPE.roleName}}">
                            <mat-panel-title>
                                <div class="role-title">
                                    <span *ngIf="FRPE.roleIsSiteLevel" class="role-member-count">
                                        <mat-icon *ngIf="FRPE.roleIsSiteLevel" class="material-icons-outlined" title="Site-level">collections</mat-icon>
                                    </span>
                                    <span *ngIf="!FRPE.roleIsSiteLevel" class="role-member-count">
                                        <mat-icon title="User Members" class="role-member-count-icon">group</mat-icon>
                                        {{FRPE.folderRoleMembers ? FRPE.folderRoleMembers.length : 0}}
                                    </span>
                                </div>
                                <div>
                                    <span class="role-member-name">
                                        <strong class="role-name">{{FRPE.roleName}}</strong>
                                    </span>
                                </div>
                            </mat-panel-title>

                            <div class="perm-indicator">
                                <mat-icon title="Folders" class="perm-indicator-type" [ngClass]="(FRPE.canViewFolder || FRPE.canCreateFolder || FRPE.canDeleteFolder) ? 'perm-on' : 'perm-off'">folder</mat-icon>
                                <mat-icon title="Create Folders" class="material-icons-outlined" [ngClass]="FRPE.canCreateFolder ? 'perm-on' : 'perm-off'">add</mat-icon>
                                <mat-icon title="Delete Folders" class="material-icons-outlined" [ngClass]="FRPE.canDeleteFolder ? 'perm-on' : 'perm-off'">close</mat-icon>
                                <mat-icon title="View Folders" class="material-icons-outlined" [ngClass]="FRPE.canViewFolder ? 'perm-on' : 'perm-off'">visibility</mat-icon>
                                &nbsp; &nbsp;
                                <mat-icon title="Forms" class="perm-indicator-type" [ngClass]="(FRPE.canCreateForm || FRPE.canDeleteForm) ? 'perm-on' : 'perm-off'">article</mat-icon>
                                <mat-icon title="Create Forms" class="material-icons-outlined" [ngClass]="FRPE.canCreateForm ? 'perm-on' : 'perm-off'">add</mat-icon>
                                <mat-icon title="Delete Forms" class="material-icons-outlined" [ngClass]="FRPE.canDeleteForm ? 'perm-on' : 'perm-off'">close</mat-icon>
                                &nbsp; &nbsp;
                                <mat-icon title="Grant Permissions" class="material-icons-outlined" [ngClass]="FRPE.canGrantPermission ? 'perm-on' : 'perm-off'">library_add_check</mat-icon>
                                &nbsp;
                                <mat-icon title="Manage Role Members" class="material-icons-outlined" [ngClass]="FRPE.canManageRoleMembers ? 'perm-on' : 'perm-off'">group_add</mat-icon>
                                <span *ngIf="FRPE.roleIsSiteLevel">
                                    &nbsp; &nbsp;
                                    <mat-icon title="Form Field Constraints" class="material-icons-outlined" [ngClass]="FRPE.canBuildConstraints ? 'perm-on' : 'perm-off'">transform</mat-icon>
                                    <mat-icon title="Workflow" class="material-icons-outlined" [ngClass]="FRPE.canBuildWorkflows ? 'perm-on' : 'perm-off'">timeline</mat-icon>
                                    <mat-icon svgIcon="material-export-notes" title="Publishing" [ngClass]="FRPE.canPublish ? 'perm-on' : 'perm-off'"></mat-icon>
                                    &nbsp; &nbsp;
                                    <span [ngClass]="FRPE.canEditFormTemplateHtml ? 'perm-on' : 'perm-off'">
                                        <span style="position: absolute;">F</span>
                                        <mat-icon style="margin-left: 10px;" title="Edit Forms HTML" class="material-icons-outlined">code</mat-icon>
                                    </span>
                                    &nbsp;
                                    <span [ngClass]="FRPE.canEditSiteHomePageHtml ? 'perm-on' : 'perm-off'">
                                        <span style="position: absolute;">H</span>
                                        <mat-icon style="margin-left: 10px;" title="Edit Site HTML" class="material-icons-outlined">code</mat-icon>
                                    </span>
                                </span>
                            </div>
                        </mat-expansion-panel-header>

                        <ng-container *ngIf="FRPE.folderRoleMembers">
                            <div *ngFor="let memb of FRPE.folderRoleMembers">
                                <div class="folder-role-member">
                                    <span class="folder-role-member-span">
                                        <span *ngIf="!FRPE.roleIsSiteLevel"
                                              class="remove-member-button"
                                              title="remove {{memb.member}}"
                                              (click)="removeFolderRoleMember(FRPE, memb)">
                                            <mat-icon>close</mat-icon>
                                        </span>
                                        <span class="folder-role-member-name">{{MemberDisplayName(memb)}}</span>
                                    </span>
                                </div>
                            </div>
                        </ng-container>
                        <br />
                        <span *ngIf="FRPE.roleIsSiteLevel" class="margin-left-15">&nbsp;&nbsp;Manage members on Site-level Roles tab.<br /><br /></span>
                        <form *ngIf="!FRPE.roleIsSiteLevel" matForm [formGroup]="addMemberForm">
                            <div>
                                <mat-form-field appearance="outline" [floatLabel]="'always'" class="add-member-control">
                                    <mat-label>Add Member or Group</mat-label>
                                    <input matInput id="add-role-member-input" formControlName="user" [matAutocomplete]="addMemberAutoComplete" cdkFocusInitial>
                                    <span matSuffix *ngIf="showLoadingIndicator"><mat-spinner [diameter]="25"></mat-spinner></span>
                                    <mat-autocomplete #addMemberAutoComplete [panelWidth]="750" [displayWith]="displayUserName">
                                        <mat-option *ngFor="let pi of pickerItems | async" [value]="pi">
                                            <span title="{{pi.fullDisplay}}">{{pi.fullDisplay}}</span>
                                        </mat-option>
                                    </mat-autocomplete>
                                </mat-form-field>
                                <button mat-flat-button matSuffix
                                        class="add-member-btn theme-primary-btn"
                                        color="primary"
                                        title="FRPE id {{FRPE.id}}"
                                        [disabled]="!addMemberForm.value.user.key"
                                        (click)="addMember(FRPE.id)">
                                    Add
                                </button>
                            </div>
                        </form>
                    </mat-expansion-panel>
                </div>
            </div>
        </mat-tab>
    </mat-tab-group>

    <mat-drawer #drawer
                mode="over"
                position="end"
                class="drawer-fixed"
                (closedStart)="this.drawerClosing()">
        <mat-toolbar>
            <span class="drawer-title">{{this.DrawerTitle}}</span>
            <span class="info-drawer-toolbar-spacer"></span>
            <button mat-icon-button (click)="this.closeDrawer()" tabindex="-1"><mat-icon>close</mat-icon></button>
        </mat-toolbar>

        <app-role-membership-drawer *ngIf="this.DrawerComponentLiaison != null"
                                    [drawerComponentLiaison]="this.DrawerComponentLiaison"></app-role-membership-drawer>
    </mat-drawer>
</mat-drawer-container>
